var app = angular.module("leonardo");

var PropertyForm = function($scope, $rootScope, $controller, propertyObj, $state, PropertyService, AuthDataService,
                            FieldSubgroupService, ngDialog, FormErrorsService, FilterService,
                            $timeout, PermissionService, AuthService) {

  $scope.property = propertyObj;
  $scope.tabsCollapsed = ['level', 'integration-settings', 'charge-codes', 'contacts', 'billing'];
  $scope.mode = 'property';
  $scope.action = $state.current.action;
  $scope.property.chargeCodes = [];
  $scope.init = false;
  $scope.AuthDataService = AuthDataService;
  $scope.authService = AuthService;

  $scope.IsReadOnlyMode = !PermissionService.isOwner() && PermissionService.permissionAvailable('permission_read_only_property', $scope.property);     
   
  $controller('PropertyBaseForm', { $scope: $scope });

  $scope.chargeCodeService();
  if ($scope.property.name !== undefined) {
    $state.current.title = 'Edit Property : ' + $scope.property.name;
  }

  $scope.editChargeCode = function(charge, amount) {
    if(typeof amount === "string" && $scope.init){
      charge.edit({property: $scope.property.id, default_amount: amount})
    }
  };

  $scope.deleteChargeCode = function(charge) {
    charge.edit({property: $scope.property.id, default_amount: null}).then(function (result) {
      $scope.chargeCodeService();
    });
  };

  $scope.toggleTab = function(tab) {
    if ($scope.tabHidden(tab)) {
      $scope.tabsCollapsed.splice($scope.tabsCollapsed.indexOf(tab), 1);
    }
    else {
      $scope.tabsCollapsed.push(tab);
    }
  };

  $scope.tabHidden = function(tab) {
    return _.contains($scope.tabsCollapsed, tab);
  };

  $scope.groupVisible = function(group) {
    var anyVisible = false;

    angular.forEach(group.subgroups, function(subgroup) {
      if (subgroup.data['property_widget'] !== 'hidden') {
        anyVisible = true;
      }
    });
    return anyVisible;
  };

  $scope.showOkMessage = function(){
    ngDialog.open({
      template: 'views/templates/dialog/property/success.html',
      controller: 'SuccessDialog',
      data: {uri: 'portfolios.overview'}
    });
  };

  $scope.clearError = function () {
    $scope.Form.name.$setValidity('unique', true);
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.action === 'create') {
      PropertyService.post(data).then(function (result) {
        PropertyService.updateCollection(result);
        $rootScope.$broadcast('property:added', result);
        $scope.showOkMessage();
        FilterService.setProperty(result);
      }, function(error){
        setValidity(error);
      });
    }
    else {
      propertyObj.patch(data).then(function (result) {
        $scope.showOkMessage();
        PropertyService.updateCollection(result);
        $rootScope.$broadcast('property:updated', result);
      }, function(error){
        setValidity(error);
      });
    }
  };

  function setValidity(error) {
    if (error.data.name) {
      $scope.Form.name.$setValidity('unique', false);
    }
    FormErrorsService.goToError();
  }

  $scope.prepareFields = function() {
    var groups = {};
    $scope.fields = [];

    var otherGroup = {
      key: '-other-',
      name: 'Other',
      subgroups: []
    };

    angular.forEach($scope.fieldSubgroups, function(subgroup) {
      var group = null;
      if (!subgroup.group) {
        otherGroup.subgroups.push(subgroup);
        return;
      }
      if (subgroup.group.key in groups) {
        group = groups[subgroup.group.key];
      }
      else {
        group = {
          key: subgroup.group.key,
          name: subgroup.group.name,
          subgroups: []
        };
        groups[subgroup.group.key] = group;
        $scope.fields.push(group);
      }

      if ($scope.action === 'edit') {
        if (subgroup.key === 'working_days') {
          var found = false;
          angular.forEach($scope.field_data, function(value, index){
            if(/^working_days_/.test(index)){
              found = true;
            }
          });
          if (!found) {
            $scope.field_data.working_days_all = true;
            $scope.field_data.working_days_f = true;
            $scope.field_data.working_days_m = true;
            $scope.field_data.working_days_s = true;
            $scope.field_data.working_days_su = true;
            $scope.field_data.working_days_t = true;
            $scope.field_data.working_days_th = true;
            $scope.field_data.working_days_x = true;
          }
        }
      }
      group.subgroups.push(subgroup);
    });
    $scope.fields.push(otherGroup);
    $scope.fields.forEach(function (group) {
          $scope.tabsCollapsed.push(group.key);
    })
  };

  $scope.overridableInitParams = function() {
    $scope.field_data = $scope.property.fields;

    $scope.prepareFields();
  };

  $scope.alterData = function(data) {
    data.fields = {};
    angular.forEach($scope.field_data, function(value, key) {
      if (value) {
        if (key === 'property_complete_address'){
          data.longitude = value.long;
          data.latitude = value.lat;
          data.fields[key] = value.address;
          data.fields['city'] = value.city;
          data.fields['state'] = value.state;
        }
        else {
          if (!_.contains(['city', 'state'], key)) {
            data.fields[key] = value;
          }
        }
      }
    });
    if (!isEmpty(data.pms_platform)) {
      if (angular.isArray(data.pms_platform)) {
        data.fields['property_management'] = data.pms_platform[0]?.name;
        data.pms_platform = data.pms_platform[0]?.id;
      }
    }
    else {
      delete(data.pms_platform);
    }
  };

  $scope.disableAllInputs = function () {
    setTimeout(function () {
      document.querySelectorAll('input[type=text] , input[type=email],  div.wrapper-select').forEach(function (elem) {
        elem.setAttribute('disabled', true);
        elem.style.border = 'none';
        elem.style.color = '#000';
      });

      document.querySelectorAll('div[wp-form-checkbox], div.wrapper-select, div.form-item, div.wrapper-contacts').forEach(function (elem) {
        elem.style.pointerEvents = 'none';
        if (elem.querySelector('select')) {
          elem.querySelector('select').style.appearance = 'none';
        }
        if (elem.querySelector('div.wrapper-checkbox') && elem.querySelector('icon').getAttribute('icon-color') === 'secondaryColor') {
          elem.querySelectorAll('div.wrapper-checkbox > icon > ng-include > svg g rect').forEach(function (innerelem) {
            innerelem.style.fill = "#949494";
          });
        }
        if (elem.querySelector('div.wrapper-checkbox') && elem.querySelector('icon').getAttribute('icon-color') === 'white') {
          elem.querySelectorAll('div.wrapper-checkbox > icon').forEach(function (innerelem) {
            innerelem.style.visibility = "hidden";
          });
        }
      });
      document.querySelector('div.btn').style.backgroundColor = '#949494';
      document.querySelector('div.btn').style.pointerEvents = 'none';
    }, 2000);
  };

  FieldSubgroupService.getAll({sector: AuthDataService.authData.account ? AuthDataService.authData.account.sector : ''}).then(function(data){
    $scope.fieldSubgroups = data;
    $scope.initParams();
    $timeout(function () {
      $scope.init = true;
      if($scope.IsReadOnlyMode) {
        $scope.disableAllInputs();
      }
    }, 1000);
  });
};

app.controller('PropertyForm', ['$scope', '$rootScope', '$controller', 'propertyObj', '$state', 'PropertyService',
  'AuthDataService', 'FieldSubgroupService', 'ngDialog', 'FormErrorsService', 'FilterService',
  '$timeout', 'PermissionService', 'AuthService', PropertyForm]);
